<!--<div class="modal fade show" id="messages-modal" tabindex="-1" role="dialog" style="padding-right: 8px; display: block;"> -->
<mat-dialog-content id="buzon" class="modal-dialog width-modal-pqrd">
  <div class="modal-content" style="height: 100%">
    <div class="modal-header buzon">
      <h2 class="modal-title unbold">
        {{ "buzon_de_preguntas" | translate
        }}<small> ({{ data.user.username }})</small>
      </h2>
      <span class="dismiss-modal" (click)="dialogRef.close()">X</span>
    </div>
    <div class="modal-body py-0 mt-3">
      <div class="row" style="height: 100%">
        <div class="col-4 right-border over-y">
          <div class="row">
            @for (b of buzon(); track b) {
              <div
                style="cursor: pointer"
                class="col-12 message-item"
                (click)="
                  cuerpo(
                    b.body,
                    b.creation_date || '',
                    b.subject_contact.subject || ''
                  )
                "
              >
                <h3 class="unbold dark-blue-text message-tittle">
                  {{ b.subject_contact.subject }}
                </h3>
                <span class="message-date gray-text">{{
                  b.creation_date | date
                }}</span>
              </div>
            }
          </div>
        </div>
        <div class="col-8 message-content pt-3">
          <div class="text-end">
            {{ fecha() | date }}
          </div>
          <h2 class="unbold dark-blue-text  mb-3">{{ pqrd() }}</h2>
          <p>{{ body() }}</p>
          @if (!body()) {
            <div class="text-center">
              <i
                class="fa fa-envelope"
                style="font-size: 20pt; color: lightgrey"
              ></i>
              <p style="color: lightgrey">
                {{ "$haz_click_en_una_pregunta" | translate }}
              </p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<!--</div>-->
